import type { Tom } from '../../../src/lib/situacaoAcordo.ts';

/**
 * Classes Tailwind de cada tom das etiquetas de situação (boleto, acordo).
 *
 * Arquivo à parte, sem componente: exportar constante de um .tsx de componente
 * quebra o recarregamento rápido do Vite naquele arquivo.
 */
export const COR_TOM: Record<Tom, { texto: string; icone: string; chip: string; faixa: string; trilho: string }> = {
    ok: {
        texto: 'text-emerald-800 dark:text-emerald-200',
        icone: 'text-emerald-600 dark:text-emerald-400',
        chip: 'bg-emerald-50 text-emerald-800 ring-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200 dark:ring-emerald-800',
        faixa: 'border-l-emerald-500',
        trilho: 'bg-emerald-500',
    },
    atencao: {
        texto: 'text-amber-800 dark:text-amber-200',
        icone: 'text-amber-600 dark:text-amber-400',
        chip: 'bg-amber-50 text-amber-800 ring-amber-200 dark:bg-amber-900/30 dark:text-amber-200 dark:ring-amber-800',
        faixa: 'border-l-amber-500',
        trilho: 'bg-amber-400',
    },
    perigo: {
        texto: 'text-red-800 dark:text-red-200',
        icone: 'text-red-600 dark:text-red-400',
        chip: 'bg-red-50 text-red-700 ring-red-200 dark:bg-red-950/40 dark:text-red-300 dark:ring-red-900',
        faixa: 'border-l-red-500',
        trilho: 'bg-red-500',
    },
    info: {
        texto: 'text-blue-800 dark:text-blue-200',
        icone: 'text-blue-600 dark:text-blue-400',
        chip: 'bg-blue-50 text-blue-800 ring-blue-200 dark:bg-blue-900/30 dark:text-blue-200 dark:ring-blue-800',
        faixa: 'border-l-blue-500',
        trilho: 'bg-blue-400',
    },
    neutro: {
        texto: 'text-gray-600 dark:text-gray-300',
        icone: 'text-gray-400',
        chip: 'bg-gray-100 text-gray-600 ring-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:ring-gray-600',
        faixa: 'border-l-gray-300 dark:border-l-gray-600',
        trilho: 'bg-gray-300 dark:bg-gray-600',
    },
};
